import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden pt-8 pb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-251">
      <div className="flex flex-col items-center text-center" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="w-full max-w-5xl rounded-[32px] overflow-hidden shadow-2xl mb-10 relative" data-id="element-253">
          <img src="https://cdn.magicpatterns.com/uploads/t6kfYm4Gxjb4JQCzzP6pnB/banner_pag.png" alt="White Ferrero Cookie pulled apart" className="w-full h-[40vh] md:h-[60vh] object-cover" data-id="element-254" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-255"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-3xl" data-id="element-256">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-brand-purple mb-6 leading-tight" data-id="element-257">
            DANGEROUSLY STUFFED.
            <br data-id="element-258" />
            HAND-CRAFTED.
            <br data-id="element-259" />
            SHIPPED FRESH.
          </h1>
          <p className="text-lg md:text-xl text-brand-purple/80 mb-10 font-medium max-w-2xl mx-auto" data-id="element-260">
            Experience the ultimate indulgence. Our gourmet cookies are packed
            with premium ingredients and baked to perfection.
          </p>

          <a href="#menu" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-brand-purple rounded-full hover:bg-brand-purple/90 hover:scale-105 transition-all duration-300 shadow-lg" data-id="element-261">
            BUILD YOUR 4-PACK BOX 📦
          </a>
        </motion.div>
      </div>
    </section>;
}